const config = __CONFIG__

export const isProd = () => !__DEV__ && config.ENVIRONMENT === 'prod'
export default __CONFIG__
